// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.stories.show.pc").length) return;
  // クエリパラメータ設定
  const paramObj = {};
  const params = location.search.substring(1).split("&");
  let i;
  for (i = 0; params[i]; i += 1) {
    const k = params[i].split("=");
    paramObj[k[0]] = k[1];
  }

  if (paramObj.open_modal_publish == "true") {
    $("#modalStoryPublished").modal();
  }
  // 右上のコメントナビ表示・非表示
  $("button.commentNavButton").click(function () {
    const commentNav = $(this).siblings(".commentNav");
    commentNav.toggleClass("open");
  });
  $("button.replyNavButton").click(function () {
    const replyNav = $(this).siblings(".replyNav");
    replyNav.toggleClass("open");
  });
  // コメントの返信入力欄表示
  $("button.reply").click(function () {
    const replyField = $(this).siblings(".replyField");
    $(this).addClass("closed");
    replyField.addClass("open");
  });
  // コメントの返信入力欄非表示
  $("button.closeReplyField").click(function () {
    const replyField = $(this).parent();
    const replyButton = replyField.siblings(".reply");
    replyButton.removeClass("closed");
    replyField.removeClass("open");
  });
  // コメントの返信一覧表示
  $("div.replyOutline").click(function () {
    const commentReplyOutline = $(this).parents("div.commentReplyOutline");
    const commentReply = commentReplyOutline.siblings("div.commentReply");
    commentReplyOutline.addClass("closed");
    commentReply.addClass("open");
  });
});
